export const QUESTIONS =
  process.env.REACT_APP_NAME === "olybet"
    ? [
        {
          index: 0,
          questionType: "team_score_first",
          titleEn: "Which team will score first? ",
          titleFr: "Quelle équipe va marquer en premier?",
          titleEs: "Milline tiim skoorib esimesena?",
          titleLt: "Kura komanda gūs vārtus pirmā?",
          titleRus: "Какая команда забьет первой?",
          titleSl: "Ktorý tím strelí gól ako prvý?",
          group: "Team vs Team (2x)",
        },
        {
          index: 1,
          questionType: "team_score_last",
          titleEn: "Which team will score last? ",
          titleFr: "Quelle équipe va marquer en dernier?",
          titleEs: "Milline tiim skoorib viimasena?",
          titleLt: "Kura komanda gūs vārtus pēdējā?",
          titleRus: "Какая команда забьет последней?",
          titleSl: "Ktorý tím skóruje ako posledný?",
          group: "Team vs Team (2x)",
        },
        {
          index: 2,
          questionType: "team_more_shots_on_goal",
          titleEn: "Which of these teams will have the most shots on goal?",
          titleFr: "Quelle équipe va obtenir le plus de tirs?",
          titleEs:
            "Milline nendest tiimidest sooritab enim pealeviskeid väravaraamidesse?",
          titleLt: "Kurai no šīm komandām būs visvairāk metienu pa vārtiem?",
          titleRus:
            "Какая из этих команд сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý z týchto tímov bude mať najviac striel na bránku?",
          group: "Team vs Team (4x)",
        },
        {
          index: 3,
          questionType: "team_more_goals",
          titleEn: "Which of these teams will score the most goals?",
          titleFr: "Quelle équipe va marquer le plus de buts? ",
          titleEs: "Milline nendest tiimidest skoorib enim väravaid?",
          titleLt: "Kura no šīm komandām gūs visvairāk vārtu?",
          titleRus: "Какая из этих команд забьет наибольшее количество голов?",
          titleSl: "Ktorý z týchto tímov strelí najviac gólov?",
          group: "Team vs Team (4x)",
        },
        {
          index: 4,
          questionType: "player_more_shots_on_goal",
          titleFr: "Quel joueur va obtenir le plus de tirs?",
          titleEn: "Which of these players will have the most shots on goal?",
          titleEs:
            "Milline nendest mängijatest teeb enim pealeviskeid väreavaraamidesse?",
          titleLt:
            "Kurš no šiem spēlētājiem izpildīs visvairāk metienu pa vārtiem?",
          titleRus:
            "Кто из этих игроков сделает наибольшее количество результативных передач?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac striel na bránku?",
          group: "Player vs Player (4x)",
        },
        {
          index: 5,
          questionType: "player_more_points",
          titleEn: "Which of these players will have the most points?",
          titleFr: "Quel joueur va récolter le plus de points? ",
          titleEs:
            "Milline nendest mängijatest teenib enim resultatiivsuspunkte?",
          titleLt: "Kurš no šiem spēlētājiem gūs visvairāk punktu?",
          titleRus:
            "Кто из этих игроков заработает наибольшее количество очков?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac bodov?",
          group: "Player vs Player (4x)",
        },
        {
          index: 6,
          questionType: "player_more_goals",
          titleEn: "Which of these players will have the most goals?",
          titleFr: "Quel joueur va marquer le plus de buts?",
          titleEs: "Milline nendest mängijatest skoorib enim väravaid?",
          titleLt: "Kurš no šiem spēlētājiem gūs visvairāk vārtu?",
          titleRus: "Кто из этих игроков забьет наибольшее количество голов?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac gólov?",
          group: "Player vs Player (4x)",
        },
        {
          index: 7,
          questionType: "player_more_assists",
          titleEn: "Which of these players will have the most assists?",
          titleFr: "Quel joueur va amasser le plus de mentions d’aide?",
          titleEs:
            "Milline nendest mängijatest annab enim resultatiivseid sööte?",
          titleLt:
            "Kurš no šiem spēlētājiem realizēs visvairāk rezultatīvu piespēļu?",
          titleRus:
            "Кто из этих игроков сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac asistencií?",
          group: "Player vs Player (4x)",
        },
        {
          index: 8,
          titleEn: "Who will win?",
          titleSl: "Kto vyhrá?",
          titleEs: "Kes võidab?",
          titleLt: "Kurš uzvarēs?",
          titleRus: "Кто выиграет?",
          group: "Team vs Team (2x)",
          questionType: "team_win",
        },
        {
          titleEn: "Will Player get at least X shots on goal?",
          titleEs: "Kas mängija teeb vähemalt X pealeviset väravaraamidesse?",
          titleLt: "Vai spēlētājs izpildīs vismaz X metienus pa vārtiem?",
          titleRus: "Сделает ли Игрок не менее X бросков в створ ворот?",
          titleSl: "Získa hráč aspoň X striel na bránku?",
          group: "True/False",
          questionType: "true_false",
          index: 9,
        },
        {
          titleEn: "When will the 1st goal of the game be scored?",
          titleEs: "Millal skooritakse mängu esimene värav?",
          titleLt: "Kad tiks gūti spēles pirmie vārti?",
          titleRus: "Когда будет забит первый гол в матче?",
          titleSl: "Kedy padne 1. gól zápasu?",
          group: "Pepsi Goalie Challenge",
          questionType: "team_score_first",
          index: 10,
        },
        {
          titleEn: "Which of these teams will score the most power play Goals?",
          titleEs:
            'Milline nendest tiimidest skoorib enim "power play" väravaid?',
          titleLt: "Kura no šīm komandām gūs visvairāk vārtu vairākumā?",
          titleRus:
            "Какая из этих команд забьет наибольшее количество голов в большинстве?",
          titleSl: "Ktorý z týchto tímov strelí najviac gólov v presilovkách?",
          group: "Team vs Team (4x)",
          questionType: "team_more_power_play_goals",
          index: 11,
        },
        {
          titleEn:
            "Which of these teams will score their 1st goal at the earliest minute and second?",
          titleEs:
            "Milline nendest tiimidest skoorib enda esimese värava kõige kiiremini?",
          titleLt:
            "Kura no šīm komandām gūs savus pirmos vārtus visagrākajā minūtē un sekundē?",
          titleRus:
            "Какая из этих команд забьет свой 1-й гол на самой ранней минуте и секунде?",
          titleSl:
            "Ktorý z týchto tímov strelí svoj 1. gól najskôr v minúte a sekunde?",
          group: "Team vs Team (4x)",
          questionType: "team_score_first",
          index: 12,
        },
        {
          titleEn:
            "Which of these games will have the most goals scored in regular time?",
          titleEs:
            "Millisel nendest mängudest skooritakse enim väravaid normaalajal?",
          titleLt: "Kurā no šīm spēlēm būs visvairāk gūto vārtu pamatlaikā?",
          titleRus:
            "Какая из этих команд забьет наибольшее количество голов в основное время?",
          titleSl:
            "V ktorom z týchto zápasov padne najviac gólov v riadnom hracom čase?",
          group: "Game vs Game (2x)",
          questionType: "game_more_goals",
          index: 13,
        },
        {
          titleEn: "Which team will have the most shots on goal?",
          titleEs: "Milline tiim teeb enim pealeviskeid väravaraamidesse?",
          titleLt: "Kura komanda izpildīs visvairāk metienu pa vārtiem?",
          titleRus:
            "Какая команда сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý tím bude mať najviac striel na bránku?",
          group: "Team vs Team (2x)",
          questionType: "team_more_shots_on_goal",
          index: 14,
        },
        {
          titleEn: "Which team will score the most goals?",
          titleEs: "Milline tiim skoorib enim väravaid?",
          titleLt: "Kura komanda gūs visvairāk vārtu?",
          titleRus: "Какая команда забьет наибольшее количество голов?",
          titleSl: "Ktorý tím strelí najviac gólov?",
          group: "Team vs Team (2x)",
          questionType: "team_more_goals",
          index: 15,
        },
        {
          titleEn: "Which team will score the most power play Goals?",
          titleEs: 'Milline tiim skoorib enim "power play" väravaid?',
          titleLt: "Kura komanda gūs visvairāk vārtu vairākumā?",
          titleRus:
            "Какая команда забьет наибольшее количество голов в большинстве?",
          titleSl: "Ktorý tím strelí najviac gólov v presilovkách?",
          group: "Team vs Team (2x)",
          questionType: "team_more_power_play_goals",
          index: 16,
        },
        {
          titleEn: "Will this game go into OT?",
          titleEs: "Kas see mäng läheb lisaajale ?",
          titleLt: "Vai šajā spēlē tiks aizvadīts pagarinājums ?",
          titleRus: "Будет ли в этом матче овертайм ?",
          titleSl: "Dôjde tento zápas  do predĺženia ?",
          group: "True/False",
          questionType: "true_false",
          index: 17,
        },
        {
          titleEn: "Will this game go to a Shootout?",
          titleEs: "Kas see mäng läheb karistusvisete seeriasse ?",
          titleLt: "Vai šajā spēlē tiks aizvadīti pēcspēles soda metieni ?",
          titleRus: "Будет ли в этом матче серия буллитов ?",
          titleSl: "Dôjde tento zápas do nájazdov ?",
          group: "True/False",
          questionType: "true_false",
          index: 18,
        },
        {
          titleEn: "Will this game have over X.5 goals scored combined?",
          titleEs: "Kas selles mängus skooritakse kokku üle X .5 värava ?",
          titleLt: "Vai šajā spēlē kopā tiks gūti vairāk nekā X, 5 vārti ?",
          titleRus: "Будет ли в этом матче забито более Х .5 голов вместе ?",
          titleSl: "Padne v tomto zápase viac ako X, 5 gólu ?",
          group: "True/False",
          questionType: "true_false",
          index: 19,
        },
        {
          titleEn: "Will <team> score over/under X.5 goals?",
          titleEs: "Kas < team > skoorib üle / alla X .5 värava ?",
          titleLt: "Vai < team > gūs vairāk / mazāk par X, 5 vārtiem ?",
          titleRus: "Забьет ли < team > больше / меньше X .5 голов ?",
          titleSl: "Strelí < team > viac ako / pod X, 5 gólu ?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 20,
        },
        {
          titleEn: "Will <team> have over/under X.5 shots on goal?",
          titleEs:
            "Kas < team > teeb üle / alla X .5 pealeviske väravaraamidesse ?",
          titleLt:
            "Vai < team > izdarīs vairāk vai mazāk par X, 5 metieniem pa vārtiem ?",
          titleRus:
            "Сделает ли < team > больше / меньше X .5 бросков в створ ворот ?",
          titleSl: "Bude mať < team > viac / menej ako X, 5 striel na bránku ?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 21,
        },
        {
          titleEn: "Will <team> have over/under X.5 power play goals?",
          titleEs: 'Kas < team > skoorib üle / alla X .5 "power play" värava ?',
          titleLt: "Vai < team > gūs vairāk / mazāk vārtus vairākumā ?",
          titleRus:
            "Забьет ли < team > больше / меньше X .5 голов в большинстве ?",
          titleSl:
            "Bude mať < team > viac ako / pod X, 5 gólov v presilovkách ?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 22,
        },
        {
          titleEn: "Will <team> have over/under X.5 blocked shots?",
          titleEs: "Kas < team > blokib üle / alla X .5 pealeviske ?",
          titleLt:
            "Vai < team > reģistrēs vairāk / mazāk par X .5 atvairītām ripām ?",
          titleRus: "Сделает ли < team > больше / меньше X .5 блок - шотов ?",
          titleSl:
            "Bude mať < team > viac / menej ako X, 5 zblokovaných striel ?}",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 23,
        },
        {
          titleEn: "Will <team> win by over x.5 goals?",
          titleEs: "Kas < team > võidab üle x .5 väravaga ?",
          titleLt: "Vai < team > uzvarēs ar vairāk nekā X, 5 vārtu pārsvaru ?",
          titleRus: "Выиграет ли < team > с разницей больше X .5 голов ?",
          titleSl: "Vyhrá < team > o viac ako x, 5 gólu ?",
          group: "True/False",
          questionType: "true_false",
          index: 24,
        },
        {
          titleEn: "Will <team> score in the 1st  period?",
          titleEs: "Kas < team > skoorib 1. kolmandikul ?",
          titleLt: "Vai < team > gūs vārtus 1. periodā ?",
          titleRus: "Забьет ли < team > гол в 1 - м периоде ?",
          titleSl: "Dá < team > gól v 1. tretine ?",
          group: "True/False",
          questionType: "true_false",
          index: 25,
        },
        {
          titleEn: "Will <team> score in the 2nd period?",
          titleEs: "Kas < team > skoorib 2. kolmandikul ?",
          titleLt: "Vai < team > gūs vārtus 2. periodā ?",
          titleRus: "Забьет ли < team > гол во 2 - м периоде ?",
          titleSl: "Dá < team > gól v 2. tretine ?",
          group: "True/False",
          questionType: "true_false",
          index: 26,
        },
        {
          titleEn: "Will <team> score in the 3rd period?",
          titleEs: "Kas < team > skoorib 3. kolmandikul ?",
          titleLt: "Vai < team > gūs vārtus 3. periodā ?",
          titleRus: "Забьет ли < team > гол в 3 - м периоде ?",
          titleSl: "Dá < team > gól v 3. tretine ?",
          group: "True/False",
          questionType: "true_false",
          index: 27,
        },
        {
          titleEn: "Will <team> score first?",
          titleEs: "Kas <team> skoorib esimesena?",
          titleLt: "Vai <team> gūs vārtus pirmā?",
          titleRus: "Забьет ли <team> первый гол?",
          titleSl: "<team> skóruje ako prvý?",
          group: "True/False",
          questionType: "true_false",
          index: 28,
        },
        {
          titleEn: "Will <team> score last?",
          titleEs: "Kas <team> skoorib viimasena?",
          titleLt: "Vai <team> gūs vārtus?",
          titleRus: "Забьет ли <team> последний гол?",
          titleSl: "<team> skóruje ako posledný?",
          questionType: "true_false",
          group: "True/False",
          index: 29,
        },
        {
          titleEn: "Which player will have the most points?",
          titleEs: "Milline mängija teenib enim resultatiivsuspunkte?",
          titleLt: "Kurš no spēlētājam gūs visvairāk punktu?",
          titleRus: "Какой игрок заработает наибольшее количество очков?",
          titleSl: "Ktorý hráč bude mať najviac bodov?",
          group: "Player vs Player (2x)",
          questionType: "player_more_points",
          index: 30,
        },
        {
          titleEn: "Which player will have the most goals?",
          titleEs: "Milline mängija viskab enim väravaid?",
          titleLt: "Kurš spēlētājs gūs visvairāk vārtu?",
          titleRus: "Какой игрок забьет наибольшее количество голов?",
          titleSl: "Ktorý hráč bude mať najviac gólov?",
          group: "Player vs Player (2x)",
          questionType: "player_more_goals",
          index: 31,
        },
        {
          titleEn: "Which player will have the most assists?",
          titleEs: "Milline mängija annab enim resultatiivseid sööte?",
          titleLt: "Kurš spēlētājs realizēs visvairāk rezultatīvu piespēļu?",
          titleRus:
            "Какой игрок сделает наибольшее количество результативных передач?",
          titleSl: "Ktorý hráč bude mať najviac asistencií?",
          group: "Player vs Player (4x)",
          questionType: "player_more_assists",
          index: 32,
        },
        {
          titleEn: "Which player will have the most shots on goal?",
          titleEs: "Milline mängija teeb enim pealeviskeid väravaraamidesse?",
          titleLt: "Kurš spēlētājs izpildīs visvairāk metienu pa vārtiem?",
          titleRus:
            "Какой игрок сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý hráč bude mať najviac striel na bránku",
          group: "Player vs Player (4x)",
          questionType: "player_more_shots_on_goal",
          index: 33,
        },
        {
          titleEn: "Will Player score over/under X.5 goals?",
          titleEs: "Kas mängija skoorib üle/alla X.5 värava?",
          titleLt: "Vai spēlētājs gūs vairāk/mazāk par X,5 vārtiem?",
          titleRus: "Забьет ли Игрок больше/меньше X.5 голов?",
          titleSl: "Strelí hráč viac/menej ako X,5 gólu?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 34,
        },
        {
          titleEn: "Will Player have over/under X.5 assists?",
          titleEs: "Kas mängija annab üle/alla X.5 resultatiivse söödu?",
          titleLt: "Vai spēlētājs realizēs vairāk/mazāk nekā X,5 piespēles?",
          titleRus:
            "Сделает ли Игрок больше/меньше X.5 результативных передач?",
          titleSl: "Bude mať hráč viac/menej ako X,5 asistencií?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 35,
        },
        {
          titleEn: "Will Player have over/under X.5 pts?",
          titleEs: "Kas mängija teenib üle/alla X.5 resultatiivsuspunkti?",
          titleLt: "Vai spēlētājs gūs vairāk/mazāk nekā X,5 punktus",
          titleRus: "Получит ли Игрок больше/меньше X.5 очков?",
          titleSl: "Bude mať hráč viac/menej ako X,5 bodov?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 36,
        },
        {
          titleEn: "Will Player have over/under X.5 shots on goal?",
          titleEs: "Kas mängija teeb üle/alla X.5 pealeviset väravaraamidesse?",
          titleLt:
            "Vai spēlētājs izpildīs vairāk/mazāk nekā X,5 metienus pa vārtiem?",
          titleRus: "Сделает ли Игрок больше/меньше X.5 бросков в створ ворот?",
          titleSl: "Bude mať Hráč viac/menej ako X,5 striel na bránu?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 37,
        },
        {
          titleEn: "Will Player have over/under X.5 power play goals?",
          titleEs: 'Kas mängija skoorib üle/alla X.5 "power play" värava?',
          titleLt: "Vai spēlētājs gūs vairāk/mazāk nekā X.5 vārtus vairākumā?",
          titleRus: "Забьет ли Игрок больше/меньше X.5 голов в большинстве?",
          titleSl: "Bude mať Hráč viac/menej ako X,5 gólov v presilovkách?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 38,
        },
        {
          titleEn: "Will Player score?",
          titleEs: "Kas mängija skoorib?",
          titleLt: "Vai spēlētājs gūs vārtus?",
          titleRus: "Забьет ли Игрок гол?",
          titleSl: "Bude hráč skórovať?",
          group: "True/False",
          questionType: "true_false",
          index: 39,
        },
        {
          titleEn: "Will Player score a power play goal?",
          titleEs: 'Kas mängija skoorib "power play" värava?',
          titleLt: "Vai spēlētājs gūs vārtus vairākumā?",
          titleRus: "Забьет ли Игрок гол в большинстве?",
          titleSl: "Strelí Hráč gól v presilovke?",
          group: "True/False",
          questionType: "true_false",
          index: 40,
        },
        {
          titleEn: "Will Player get at least X points?",
          titleEs: "Kas mängija teenib vähemalt X resultatiivsuspunkti?",
          titleLt: "Vai spēlētājs gūs vismaz X punktus?",
          titleRus: "Получит ли Игрок не менее Х очков?",
          titleSl: "Získa Hráč aspoň X bodov?",
          group: "True/False",
          questionType: "true_false",
          index: 41,
        },
        {
          titleEn: "Will Player get at least X goals?",
          titleEs: "Kas mängija viskab vähemalt X väravat?",
          titleLt: "Vai spēlētājs gūs vismaz X vārtus?",
          titleRus: "Забьет ли Игрок не менее Х голов?",
          titleSl: "Získa Hráč aspoň X gólov?",
          questionType: "true_false",
          group: "True/False",
          index: 42,
        },
        {
          titleEn: "Will Player get at least X assist?",
          titleEs: "Kas mängija annab vähemalt X resultatiivset söötu?",
          titleLt: "Vai spēlētājs realizēs vismaz X rezultatīvas piespēles?",
          titleRus: "Сделает ли Игрок не менее Х результативных передач?",
          titleSl: "Získa Hráč aspoň X asistencií?",
          questionType: "true_false",
          group: "True/False",
          index: 43,
        },
      ]
    : [
        {
          index: 0,
          questionType: "custom_question",
          titleEn: "Custom question",
          titleFr: "Custom question",
          group: "Custom",
        },
        {
          index: 1,
          questionType: "team_win",
          titleEn: "Who will win tonight?",
          titleFr: "Qui va gagner ce soir? ",
          group: "Team vs Team (2x)",
        },
        {
          index: 2,
          questionType: "team_win",
          titleEn: "Who will win today?",
          titleFr: "Qui va gagner aujourd’hui?",
          group: "Team vs Team (2x)",
        },
        {
          index: 3,
          questionType: "team_win",
          titleEn: "Which team will win?",
          titleFr: "Qui va gagner?",
          group: "Team vs Team (2x)",
        },
        {
          index: 4,
          questionType: "team_more_shots_on_goal",
          titleEn: "Which team will have more shots on goal?",
          titleFr: "Quelle équipe va obtenir le plus de tirs?",
          group: "Team vs Team (2x)",
        },
        {
          index: 5,
          questionType: "team_more_goals",
          titleEn: "Which team will score more goals?",
          titleFr: "Quelle équipe va marquer le plus de buts?",
          group: "Team vs Team (2x)",
        },
        {
          index: 6,
          questionType: "team_more_power_play_goals",
          titleEn: "Which team will score more power-play goals?",
          titleFr:
            "Quelle équipe va marquer le plus de buts en avantage numérique?",
          group: "Team vs Team (2x)",
        },
        {
          index: 7,
          questionType: "team_more_hits",
          titleEn: "Which team will have more Hits?",
          titleFr: "Quelle équipe va distribuer le plus de mises en échec?",
          group: "Team vs Team (2x)",
        },
        {
          index: 8,
          questionType: "team_more_blocked_shots",
          titleEn: "Which team will have more blocked shots?",
          titleFr: "Quelle équipe va bloquer le plus de tirs bloqués?",
          group: "Team vs Team (2x)",
        },
        {
          index: 9,
          questionType: "team_score_first",
          titleEn: "Which team will score first? ",
          titleFr: "Quelle équipe va marquer en premier?",
          titleEs: "Milline tiim skoorib esimesena?",
          titleLt: "Kura komanda gūs vārtus pirmā?",
          titleRus: "Какая команда забьет первой?",
          titleSl: "Ktorý tím strelí gól ako prvý?",
          group: "Team vs Team (2x)",
        },
        {
          index: 10,
          questionType: "team_score_last",
          titleEn: "Which team will score last? ",
          titleFr: "Quelle équipe va marquer en dernier?",
          titleEs: "Milline tiim skoorib viimasena?",
          titleLt: "Kura komanda gūs vārtus pēdējā?",
          titleRus: "Какая команда забьет последней?",
          titleSl: "Ktorý tím skóruje ako posledný?",
          group: "Team vs Team (2x)",
        },
        {
          index: 11,
          questionType: "team_best_face_off",
          titleEn: "Which team will have the best faceoff %?",
          titleFr:
            "Quelle équipe va afficher le meilleur pourcentage de réussite sur les mises en jeu?",
          group: "Team vs Team (2x)",
        },
        {
          index: 12,
          questionType: "team_more_shots_on_goal",
          titleEn: "Which of these teams will have the most shots on goal?",
          titleFr: "Quelle équipe va obtenir le plus de tirs?",
          titleEs:
            "Milline nendest tiimidest sooritab enim pealeviskeid väravaraamidesse?",
          titleLt: "Kurai no šīm komandām būs visvairāk metienu pa vārtiem?",
          titleRus:
            "Какая из этих команд сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý z týchto tímov bude mať najviac striel na bránku?",
          group: "Team vs Team (4x)",
        },
        {
          index: 13,
          questionType: "team_more_goals",
          titleEn: "Which of these teams will score the most goals?",
          titleFr: "Quelle équipe va marquer le plus de buts? ",
          titleEs: "Milline nendest tiimidest skoorib enim väravaid?",
          titleLt: "Kura no šīm komandām gūs visvairāk vārtu?",
          titleRus: "Какая из этих команд забьет наибольшее количество голов?",
          titleSl: "Ktorý z týchto tímov strelí najviac gólov?",
          group: "Team vs Team (4x)",
        },
        {
          index: 14,
          questionType: "team_more_power_play_goals",
          titleEn: "Which of these teams will score the most power play goals?",
          titleFr:
            "Quelle équipe va marquer le plus de buts en avantage numérique?",
          group: "Team vs Team (4x)",
        },
        {
          index: 15,
          questionType: "team_best_face_off",
          titleEn: "Which of these teams will have the best faceoff %?",
          titleFr:
            "Quelle équipe va afficher le meilleur pourcentage de réussite sur les mises en jeu?",
          group: "Team vs Team (4x)",
        },
        {
          index: 16,
          questionType: "team_more_hits",
          titleEn: "Which of these teams will have the most hits?",
          titleFr: "Quelle équipe va distribuer le plus de mises en échec?",
          group: "Team vs Team (4x)",
        },
        {
          index: 17,
          questionType: "team_more_blocked_shots",
          titleEn: "Which of these teams will have the most blocked shots?",
          titleFr: "Quelle équipe va bloquer le plus de tirs bloqués?",
          group: "Team vs Team (4x)",
        },
        {
          index: 18,
          questionType: "player_more_points",
          titleEn: "Which player will have more points?",
          titleFr: "Quel joueur va récolter le plus de points?",
          group: "Player vs Player (2x)",
        },
        {
          index: 19,
          questionType: "player_more_goals",
          titleEn: "Which player will score more goals?",
          titleFr: "Quel joueur va marquer le plus de buts?",
          group: "Player vs Player (2x)",
        },
        {
          index: 20,
          questionType: "player_more_assists",
          titleEn: "Which player will have more assists?",
          titleFr: "Quel joueur va amasser le plus de mentions d’aide?",
          group: "Player vs Player (2x)",
        },
        {
          index: 21,
          questionType: "player_more_shots_on_goal",
          titleEn: "Which player will have more shots on goal?",
          titleFr: "Quel joueur va obtenir le plus de tirs?",
          group: "Player vs Player (2x)",
        },
        {
          index: 22,
          questionType: "player_best_face_off",
          titleEn: "Which player will have the best faceoff %?",
          titleFr:
            "Quel joueur va afficher le meilleur pourcentage de réussite sur les mises en jeu?",
          group: "Player vs Player (2x)",
        },
        {
          index: 23,
          questionType: "player_more_shots_on_goal",
          titleFr: "Quel joueur va obtenir le plus de tirs?",
          titleEn: "Which of these players will have the most shots on goal?",
          titleEs:
            "Milline nendest mängijatest teeb enim pealeviskeid väreavaraamidesse?",
          titleLt:
            "Kurš no šiem spēlētājiem izpildīs visvairāk metienu pa vārtiem?",
          titleRus:
            "Кто из этих игроков сделает наибольшее количество результативных передач?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac striel na bránku?",
          group: "Player vs Player (4x)",
        },
        {
          index: 24,
          questionType: "player_best_face_off",
          titleEn: "Which of these players will have the best faceoff %?",
          titleFr:
            "Quel joueur va afficher le meilleur pourcentage de réussite sur les mises en jeu?",
          group: "Player vs Player (4x)",
        },
        {
          index: 25,
          questionType: "player_more_points",
          titleEn: "Which of these players will have the most points?",
          titleFr: "Quel joueur va récolter le plus de points? ",
          titleEs:
            "Milline nendest mängijatest teenib enim resultatiivsuspunkte?",
          titleLt: "Kurš no šiem spēlētājiem gūs visvairāk punktu?",
          titleRus:
            "Кто из этих игроков заработает наибольшее количество очков?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac bodov?",
          group: "Player vs Player (4x)",
        },
        {
          index: 26,
          questionType: "player_more_goals",
          titleEn: "Which of these players will have the most goals?",
          titleFr: "Quel joueur va marquer le plus de buts?",
          titleEs: "Milline nendest mängijatest skoorib enim väravaid?",
          titleLt: "Kurš no šiem spēlētājiem gūs visvairāk vārtu?",
          titleRus: "Кто из этих игроков забьет наибольшее количество голов?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac gólov?",
          group: "Player vs Player (4x)",
        },
        {
          index: 27,
          questionType: "player_more_assists",
          titleEn: "Which of these players will have the most assists?",
          titleFr: "Quel joueur va amasser le plus de mentions d’aide?",
          titleEs:
            "Milline nendest mängijatest annab enim resultatiivseid sööte?",
          titleLt:
            "Kurš no šiem spēlētājiem realizēs visvairāk rezultatīvu piespēļu?",
          titleRus:
            "Кто из этих игроков сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý z týchto hráčov bude mať najviac asistencií?",
          group: "Player vs Player (4x)",
        },
        {
          index: 28,
          questionType: "pepsi",
          titleEn: "Which goalie will record a win on Tuesday, [enter date]?",
          titleFr:
            "Quel gardien signera une victoire le mardi [entrez la date]?",
          group: "Pepsi Goalie Challenge",
        },
        {
          index: 29,
          questionType: "pepsi",
          titleEn:
            "Which goalie will record the most saves on Tuesday, [enter date]?",
          titleFr:
            "Quel gardien accumulera le plus grand nombre d'arrêts le mardi [entrez la date]?",
          group: "Pepsi Goalie Challenge",
        },
        {
          index: 30,
          questionType: "pepsi",
          titleEn:
            "Which goalie will allow the fewest goals on Tuesday, [enter date]?",
          titleFr:
            "Quel gardien allouera le plus petit nombre de buts le mardi [entrez la date]?",
          group: "Pepsi Goalie Challenge",
        },
        {
          index: 31,
          questionType: "pepsi",
          titleEn:
            "Drag and drop the Pepsi Zero Sugar can to predict which of your goalies will record a shutout",
          titleFr:
            "Glissez et déposez la canette de Pepsi Zéro Sucre pour prédire lequel de vos gardiens signera un jeu blanc",
          group: "Pepsi Goalie Challenge",
        },
        {
          index: 32,
          questionType: "over_under",
          titleEn: "Will <player> score over/under X.5 goals?",
          titleFr: "Est-ce que <player> va marquer plus/moins que X,5 buts?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 33,
          questionType: "over_under",
          titleEn: "Will <player> have over/under X.5 assists?",
          titleFr:
            "Est-ce que <player> va amasser plus/moins que X,5 mentions d’aide?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 34,
          questionType: "over_under",
          titleEn: "Will <player> have over/under X.5 points?",
          titleFr: "Est-ce que <player> va récolter plus/moins que X,5 points?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 35,
          questionType: "over_under",
          titleEn: "Will <player> have over/under X.5 shots on goal?",
          titleFr:
            "Est-ce que <player> va décocher plus/moins que X,5 tirs au but?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 36,
          questionType: "over_under",
          titleEn: "Will <player> have over/under X.5 power play goals?",
          titleFr:
            "Est-ce que <player> va marquer plus/moins que X,5 buts en avantage numérique?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 37,
          questionType: "over_under",
          titleEn: "Will <player> have over/under X.5 power play points?",
          titleFr:
            "Est-ce que <player> va récolter plus/moins que X,5 points en avantage numérique?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 38,
          questionType: "over_under",
          titleEn: "Will the <team> score over/under X.5 goals?",
          titleFr:
            "Est-ce que les <team> vont marquer plus/moins que X,5 buts?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 39,
          questionType: "over_under",
          titleEn: "Will the <team> score over/under X.5 powerplay goals?",
          titleFr:
            "Est-ce que les <team> vont marquer plus/moins que X,5 buts en avantage numérique?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 40,
          questionType: "over_under",
          titleEn: "Will the <team> have over/under X.5 shots on goal?",
          titleFr:
            "Est-ce que les <team> vont décocher plus/moins que X,5 tirs au but?",
          group: "Pepsi Over/Under Challenge",
        },
        {
          index: 41,
          titleEn: "Who will win?",
          titleSl: "Kto vyhrá?",
          titleEs: "Kes võidab?",
          titleLt: "Kurš uzvarēs?",
          titleRus: "Кто выиграет?",
          group: "Team vs Team (2x)",
          questionType: "team_win",
        },
        {
          titleEn: "Will Player get at least X shots on goal?",
          titleEs: "Kas mängija teeb vähemalt X pealeviset väravaraamidesse?",
          titleLt: "Vai spēlētājs izpildīs vismaz X metienus pa vārtiem?",
          titleRus: "Сделает ли Игрок не менее X бросков в створ ворот?",
          titleSl: "Získa hráč aspoň X striel na bránku?",
          group: "True/False",
          questionType: "true_false",
          index: 42,
        },
        {
          titleEn: "When will the 1st goal of the game be scored?",
          titleEs: "Millal skooritakse mängu esimene värav?",
          titleLt: "Kad tiks gūti spēles pirmie vārti?",
          titleRus: "Когда будет забит первый гол в матче?",
          titleSl: "Kedy padne 1. gól zápasu?",
          group: "Pepsi Goalie Challenge",
          questionType: "team_score_first",
          index: 43,
        },
        {
          titleEn: "Which of these teams will score the most power play Goals?",
          titleEs:
            'Milline nendest tiimidest skoorib enim "power play" väravaid?',
          titleLt: "Kura no šīm komandām gūs visvairāk vārtu vairākumā?",
          titleRus:
            "Какая из этих команд забьет наибольшее количество голов в большинстве?",
          titleSl: "Ktorý z týchto tímov strelí najviac gólov v presilovkách?",
          group: "Team vs Team (4x)",
          questionType: "team_more_power_play_goals",
          index: 44,
        },
        {
          titleEn:
            "Which of these teams will score their 1st goal at the earliest minute and second?",
          titleEs:
            "Milline nendest tiimidest skoorib enda esimese värava kõige kiiremini?",
          titleLt:
            "Kura no šīm komandām gūs savus pirmos vārtus visagrākajā minūtē un sekundē?",
          titleRus:
            "Какая из этих команд забьет свой 1-й гол на самой ранней минуте и секунде?",
          titleSl:
            "Ktorý z týchto tímov strelí svoj 1. gól najskôr v minúte a sekunde?",
          group: "Team vs Team (4x)",
          questionType: "team_score_first",
          index: 45,
        },
        {
          titleEn:
            "Which of these games will have the most goals scored in regular time?",
          titleEs:
            "Millisel nendest mängudest skooritakse enim väravaid normaalajal?",
          titleLt: "Kurā no šīm spēlēm būs visvairāk gūto vārtu pamatlaikā?",
          titleRus:
            "Какая из этих команд забьет наибольшее количество голов в основное время?",
          titleSl:
            "V ktorom z týchto zápasov padne najviac gólov v riadnom hracom čase?",
          group: "Game vs Game (2x)",
          questionType: "game_more_goals",
          index: 46,
        },
        {
          titleEn: "Which team will have the most shots on goal?",
          titleEs: "Milline tiim teeb enim pealeviskeid väravaraamidesse?",
          titleLt: "Kura komanda izpildīs visvairāk metienu pa vārtiem?",
          titleRus:
            "Какая команда сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý tím bude mať najviac striel na bránku?",
          group: "Team vs Team (2x)",
          questionType: "team_more_shots_on_goal",
          index: 47,
        },
        {
          titleEn: "Which team will score the most goals?",
          titleEs: "Milline tiim skoorib enim väravaid?",
          titleLt: "Kura komanda gūs visvairāk vārtu?",
          titleRus: "Какая команда забьет наибольшее количество голов?",
          titleSl: "Ktorý tím strelí najviac gólov?",
          group: "Team vs Team (2x)",
          questionType: "team_more_goals",
          index: 48,
        },
        {
          titleEn: "Which team will score the most power play Goals?",
          titleEs: 'Milline tiim skoorib enim "power play" väravaid?',
          titleLt: "Kura komanda gūs visvairāk vārtu vairākumā?",
          titleRus:
            "Какая команда забьет наибольшее количество голов в большинстве?",
          titleSl: "Ktorý tím strelí najviac gólov v presilovkách?",
          group: "Team vs Team (2x)",
          questionType: "team_more_power_play_goals",
          index: 49,
        },
        {
          titleEn: "Will this game go into OT?",
          titleEs: "Kas see mäng läheb lisaajale ?",
          titleLt: "Vai šajā spēlē tiks aizvadīts pagarinājums ?",
          titleRus: "Будет ли в этом матче овертайм ?",
          titleSl: "Dôjde tento zápas  do predĺženia ?",
          group: "True/False",
          questionType: "true_false",
          index: 50,
        },
        {
          titleEn: "Will this game go to a Shootout?",
          titleEs: "Kas see mäng läheb karistusvisete seeriasse ?",
          titleLt: "Vai šajā spēlē tiks aizvadīti pēcspēles soda metieni ?",
          titleRus: "Будет ли в этом матче серия буллитов ?",
          titleSl: "Dôjde tento zápas do nájazdov ?",
          group: "True/False",
          questionType: "true_false",
          index: 51,
        },
        {
          titleEn: "Will this game have over X.5 goals scored combined?",
          titleEs: "Kas selles mängus skooritakse kokku üle X .5 värava ?",
          titleLt: "Vai šajā spēlē kopā tiks gūti vairāk nekā X, 5 vārti ?",
          titleRus: "Будет ли в этом матче забито более Х .5 голов вместе ?",
          titleSl: "Padne v tomto zápase viac ako X, 5 gólu ?",
          group: "True/False",
          questionType: "true_false",
          index: 52,
        },
        {
          titleEn: "Will <team> score over/under X.5 goals?",
          titleEs: "Kas < team > skoorib üle / alla X .5 värava ?",
          titleLt: "Vai < team > gūs vairāk / mazāk par X, 5 vārtiem ?",
          titleRus: "Забьет ли < team > больше / меньше X .5 голов ?",
          titleSl: "Strelí < team > viac ako / pod X, 5 gólu ?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 53,
        },
        {
          titleEn: "Will <team> have over/under X.5 shots on goal?",
          titleEs:
            "Kas < team > teeb üle / alla X .5 pealeviske väravaraamidesse ?",
          titleLt:
            "Vai < team > izdarīs vairāk vai mazāk par X, 5 metieniem pa vārtiem ?",
          titleRus:
            "Сделает ли < team > больше / меньше X .5 бросков в створ ворот ?",
          titleSl: "Bude mať < team > viac / menej ako X, 5 striel na bránku ?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 54,
        },
        {
          titleEn: "Will <team> have over/under X.5 power play goals?",
          titleEs: 'Kas < team > skoorib üle / alla X .5 "power play" värava ?',
          titleLt: "Vai < team > gūs vairāk / mazāk vārtus vairākumā ?",
          titleRus:
            "Забьет ли < team > больше / меньше X .5 голов в большинстве ?",
          titleSl:
            "Bude mať < team > viac ako / pod X, 5 gólov v presilovkách ?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 55,
        },
        {
          titleEn: "Will <team> have over/under X.5 blocked shots?",
          titleEs: "Kas < team > blokib üle / alla X .5 pealeviske ?",
          titleLt:
            "Vai < team > reģistrēs vairāk / mazāk par X .5 atvairītām ripām ?",
          titleRus: "Сделает ли < team > больше / меньше X .5 блок - шотов ?",
          titleSl:
            "Bude mať < team > viac / menej ako X, 5 zblokovaných striel ?}",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 56,
        },
        {
          titleEn: "Will <team> win by over x.5 goals?",
          titleEs: "Kas < team > võidab üle x .5 väravaga ?",
          titleLt: "Vai < team > uzvarēs ar vairāk nekā X, 5 vārtu pārsvaru ?",
          titleRus: "Выиграет ли < team > с разницей больше X .5 голов ?",
          titleSl: "Vyhrá < team > o viac ako x, 5 gólu ?",
          group: "True/False",
          questionType: "true_false",
          index: 57,
        },
        {
          titleEn: "Will <team> score in the 1st  period?",
          titleEs: "Kas < team > skoorib 1. kolmandikul ?",
          titleLt: "Vai < team > gūs vārtus 1. periodā ?",
          titleRus: "Забьет ли < team > гол в 1 - м периоде ?",
          titleSl: "Dá < team > gól v 1. tretine ?",
          group: "True/False",
          questionType: "true_false",
          index: 58,
        },
        {
          titleEn: "Will <team> score in the 2nd period?",
          titleEs: "Kas < team > skoorib 2. kolmandikul ?",
          titleLt: "Vai < team > gūs vārtus 2. periodā ?",
          titleRus: "Забьет ли < team > гол во 2 - м периоде ?",
          titleSl: "Dá < team > gól v 2. tretine ?",
          group: "True/False",
          questionType: "true_false",
          index: 59,
        },
        {
          titleEn: "Will <team> score in the 3rd period?",
          titleEs: "Kas < team > skoorib 3. kolmandikul ?",
          titleLt: "Vai < team > gūs vārtus 3. periodā ?",
          titleRus: "Забьет ли < team > гол в 3 - м периоде ?",
          titleSl: "Dá < team > gól v 3. tretine ?",
          group: "True/False",
          questionType: "true_false",
          index: 60,
        },
        {
          titleEn: "Will <team> score first?",
          titleEs: "Kas <team> skoorib esimesena?",
          titleLt: "Vai <team> gūs vārtus pirmā?",
          titleRus: "Забьет ли <team> первый гол?",
          titleSl: "<team> skóruje ako prvý?",
          group: "True/False",
          questionType: "true_false",
          index: 61,
        },
        {
          titleEn: "Will <team> score last?",
          titleEs: "Kas <team> skoorib viimasena?",
          titleLt: "Vai <team> gūs vārtus?",
          titleRus: "Забьет ли <team> последний гол?",
          titleSl: "<team> skóruje ako posledný?",
          questionType: "true_false",
          group: "True/False",
          index: 62,
        },
        {
          titleEn: "Which player will have the most points?",
          titleEs: "Milline mängija teenib enim resultatiivsuspunkte?",
          titleLt: "Kurš no spēlētājam gūs visvairāk punktu?",
          titleRus: "Какой игрок заработает наибольшее количество очков?",
          titleSl: "Ktorý hráč bude mať najviac bodov?",
          group: "Player vs Player (2x)",
          questionType: "player_more_points",
          index: 63,
        },
        {
          titleEn: "Which player will have the most goals?",
          titleEs: "Milline mängija viskab enim väravaid?",
          titleLt: "Kurš spēlētājs gūs visvairāk vārtu?",
          titleRus: "Какой игрок забьет наибольшее количество голов?",
          titleSl: "Ktorý hráč bude mať najviac gólov?",
          group: "Player vs Player (2x)",
          questionType: "player_more_goals",
          index: 64,
        },
        {
          titleEn: "Which player will have the most assists?",
          titleEs: "Milline mängija annab enim resultatiivseid sööte?",
          titleLt: "Kurš spēlētājs realizēs visvairāk rezultatīvu piespēļu?",
          titleRus:
            "Какой игрок сделает наибольшее количество результативных передач?",
          titleSl: "Ktorý hráč bude mať najviac asistencií?",
          group: "Player vs Player (4x)",
          questionType: "player_more_assists",
          index: 65,
        },
        {
          titleEn: "Which player will have the most shots on goal?",
          titleEs: "Milline mängija teeb enim pealeviskeid väravaraamidesse?",
          titleLt: "Kurš spēlētājs izpildīs visvairāk metienu pa vārtiem?",
          titleRus:
            "Какой игрок сделает наибольшее количество бросков в створ ворот?",
          titleSl: "Ktorý hráč bude mať najviac striel na bránku",
          group: "Player vs Player (4x)",
          questionType: "player_more_shots_on_goal",
          index: 66,
        },
        {
          titleEn: "Will Player score over/under X.5 goals?",
          titleEs: "Kas mängija skoorib üle/alla X.5 värava?",
          titleLt: "Vai spēlētājs gūs vairāk/mazāk par X,5 vārtiem?",
          titleRus: "Забьет ли Игрок больше/меньше X.5 голов?",
          titleSl: "Strelí hráč viac/menej ako X,5 gólu?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 67,
        },
        {
          titleEn: "Will Player have over/under X.5 assists?",
          titleEs: "Kas mängija annab üle/alla X.5 resultatiivse söödu?",
          titleLt: "Vai spēlētājs realizēs vairāk/mazāk nekā X,5 piespēles?",
          titleRus:
            "Сделает ли Игрок больше/меньше X.5 результативных передач?",
          titleSl: "Bude mať hráč viac/menej ako X,5 asistencií?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 68,
        },
        {
          titleEn: "Will Player have over/under X.5 pts?",
          titleEs: "Kas mängija teenib üle/alla X.5 resultatiivsuspunkti?",
          titleLt: "Vai spēlētājs gūs vairāk/mazāk nekā X,5 punktus",
          titleRus: "Получит ли Игрок больше/меньше X.5 очков?",
          titleSl: "Bude mať hráč viac/menej ako X,5 bodov?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 69,
        },
        {
          titleEn: "Will Player have over/under X.5 shots on goal?",
          titleEs: "Kas mängija teeb üle/alla X.5 pealeviset väravaraamidesse?",
          titleLt:
            "Vai spēlētājs izpildīs vairāk/mazāk nekā X,5 metienus pa vārtiem?",
          titleRus: "Сделает ли Игрок больше/меньше X.5 бросков в створ ворот?",
          titleSl: "Bude mať Hráč viac/menej ako X,5 striel na bránu?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 70,
        },
        {
          titleEn: "Will Player have over/under X.5 power play goals?",
          titleEs: 'Kas mängija skoorib üle/alla X.5 "power play" värava?',
          titleLt: "Vai spēlētājs gūs vairāk/mazāk nekā X.5 vārtus vairākumā?",
          titleRus: "Забьет ли Игрок больше/меньше X.5 голов в большинстве?",
          titleSl: "Bude mať Hráč viac/menej ako X,5 gólov v presilovkách?",
          group: "Pepsi Over/Under Challenge",
          questionType: "over_under",
          index: 71,
        },
        {
          titleEn: "Will Player score?",
          titleEs: "Kas mängija skoorib?",
          titleLt: "Vai spēlētājs gūs vārtus?",
          titleRus: "Забьет ли Игрок гол?",
          titleSl: "Bude hráč skórovať?",
          group: "True/False",
          questionType: "true_false",
          index: 72,
        },
        {
          titleEn: "Will Player score a power play goal?",
          titleEs: 'Kas mängija skoorib "power play" värava?',
          titleLt: "Vai spēlētājs gūs vārtus vairākumā?",
          titleRus: "Забьет ли Игрок гол в большинстве?",
          titleSl: "Strelí Hráč gól v presilovke?",
          group: "True/False",
          questionType: "true_false",
          index: 73,
        },
        {
          titleEn: "Will Player get at least X points?",
          titleEs: "Kas mängija teenib vähemalt X resultatiivsuspunkti?",
          titleLt: "Vai spēlētājs gūs vismaz X punktus?",
          titleRus: "Получит ли Игрок не менее Х очков?",
          titleSl: "Získa Hráč aspoň X bodov?",
          group: "True/False",
          questionType: "true_false",
          index: 74,
        },
        {
          titleEn: "Will Player get at least X goals?",
          titleEs: "Kas mängija viskab vähemalt X väravat?",
          titleLt: "Vai spēlētājs gūs vismaz X vārtus?",
          titleRus: "Забьет ли Игрок не менее Х голов?",
          titleSl: "Získa Hráč aspoň X gólov?",
          questionType: "true_false",
          group: "True/False",
          index: 75,
        },
        {
          titleEn: "Will Player get at least X assist?",
          titleEs: "Kas mängija annab vähemalt X resultatiivset söötu?",
          titleLt: "Vai spēlētājs realizēs vismaz X rezultatīvas piespēles?",
          titleRus: "Сделает ли Игрок не менее Х результативных передач?",
          titleSl: "Získa Hráč aspoň X asistencií?",
          questionType: "true_false",
          group: "True/False",
          index: 76,
        },
      ];
